import React from "react";
import { useNavigate } from "react-router";
import icons from "../../assets/images/sprite-other-icons.svg";
import { getRealBalance, setIsSearchBoxOpen } from "../signIn/cl_SignInSlice";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";

function BackArrow({ prevPage }) {
  const { searchCtg, IsSearchBoxOpen } = useSelector((state) => state?.signIn);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const goBack = () => {
    const token = getFromLocalStorage("gk");

    if(token){
      //dispatch(getRealBalance());
    }
    if (searchCtg) {
      navigate("/");
      dispatch(setIsSearchBoxOpen(true));
    } else {
      dispatch(setIsSearchBoxOpen(false));
      navigate(-1);
    }
    // if (
    //   window.location.href.indexOf("code=") > -1 &&
    //   window.location.href.indexOf("mobile=") > -1
    // ) {
    //   window.location.href = "/";
    // } else {
    //   navigate(-1);
    // }
  };
  return (
    <>
      {prevPage === "closeBtn" ? (
        <div className="SB-casinoGameClose" onClick={goBack}>
          <div className="SB-iconSVG">
            <svg xmlns="http://www.w3.org/2000/svg">
              <use xlinkHref={`${icons}#${"icon-close"}`} />
            </svg>
          </div>
        </div>
      ) : (
        <div className="SB-pageBackButton SB-iconSVG" onClick={goBack}>
          <svg xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref={`${icons}#${"icon-back"}`} />
          </svg>
        </div>
      )}
    </>
  );
}

export default BackArrow;
